import { object, string } from 'yup';
import { useEsigningAuthenticationModes } from 'app/domains/esigning/hooks/useEsigningAuthenticationModes';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { getAuthenticationModeField, getEmailField, getMobileField, getRequiredString, } from 'app/domains/esigning/utils/formSchemaFields';
export const useGetSchema = (options) => {
    const { properties } = useEsigningProviderMetadata();
    const { nameFormat, allowDuplicateEmails } = properties;
    const { authenticationModes } = useEsigningAuthenticationModes();
    const authenticationModeSlugs = authenticationModes.map((mode) => mode.slug);
    const requiredString = getRequiredString();
    const emailField = getEmailField(Object.assign(Object.assign({}, options), { allowDuplicateEmails }));
    const mobileField = getMobileField();
    const authenticationModeField = getAuthenticationModeField(authenticationModeSlugs);
    const schema = object().shape({
        email: emailField,
        mobile: mobileField,
        authenticationMode: authenticationModeField,
        label: string(),
        title: string(),
        message: string(),
    });
    const fullNameSchema = object().shape({
        name: requiredString,
    });
    const firstNameLastNameSchema = object().shape({
        firstName: requiredString,
        lastName: requiredString,
    });
    if (nameFormat === 'firstNameLastName') {
        return schema.concat(firstNameLastNameSchema);
    }
    return schema.concat(fullNameSchema);
};
